import { icon } from './common'

// primary menu toggle
for (const el of document.querySelectorAll('.open-nav-primary')) {
  el.addEventListener('click', (e) => {
    document.body.classList.add('nav-primary-open')
  })
  el.addEventListener('keypress', (e) => {
    if (['Enter', 'Space'].includes(e.code)) {
      document.body.classList.add('nav-primary-open')
      document.querySelector('.close-nav-primary')?.focus()
    }
  })
}

for (const el of document.querySelectorAll('.close-nav-primary')) {
  el.addEventListener('click', (e) => {
    document.body.classList.remove('nav-primary-open')
  })
  el.addEventListener('keypress', (e) => {
    if (['Enter', 'Space'].includes(e.code)) {
      document.body.classList.remove('nav-primary-open')
    }
  })
}

// tertiary menu toggle
for (const el of document.querySelectorAll('.open-nav-tertiary')) {
  el.addEventListener('click', (e) => {
    document.body.classList.toggle('nav-tertiary-open')
  })
}

// social menu vp-button-icon
for (const el of document.querySelectorAll('.vp-footer .nav-social a')) {
  el.classList.add('vp-button-icon')
  const iconHtml = icon(`social-${el.innerHTML}`)
  el.innerHTML = `<span>${iconHtml}<span>${iconHtml}</span></span>`
}

// close menu tertiary on click outside
document.addEventListener('click', (e) => {
  if (
    document.body.classList.contains('nav-tertiary-open') &&
    !e.target.closest('.open-nav-tertiary,.nav-tertiary')
  ) {
    document.body.classList.remove('nav-tertiary-open')
  }
})
